import React from 'react';
import { Card } from 'sa-ui';

import './ReportBarChartComparative.scss';

const ReportBarChartComparative = (props) => {
  let colors = [
    '#003049',
    '#6A4C93',
    '#FF6F61',
    '#264653',
    '#2A9D8F',
    '#E9C46A',
    '#F4A261',
    '#E76F51',
    '#D62828',
    '#F77F00',
  ];

  // Filtrar dinamicamente as chaves idsCatalogingInfoCX e gradeCX
  const catalogingKeys = Object.keys(props.generalComparativeReport).filter((key) =>
    key.startsWith('idsCatalogingInfoC'),
  );

  return (
    <Card style={{ width: '100%' }} className="chart-mobile report-bar-chart--container">
      <div style={{ color: props.titleColor }}>
        <strong>
          <i className="pe-7s-graph1 mr-2" />
          {props.title}
        </strong>
      </div>
      <div className="label-comparative">
        {catalogingKeys.map((key, index) => (
          <div className="flex" key={key}>
            <div
              className="color-square"
              style={{ backgroundColor: colors[index % colors.length] }}
            ></div>
            <div className="label">
              {`C${index + 1}(%) - ${
                props.generalComparativeReport[key]
                  ? props.generalComparativeReport[key].join('/')
                  : ''
              }`}
            </div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: '60px' }}>
        <div
          className="report-bar-chart flexArea"
          style={{
            margin: props.area ? '20px 0 60px' : '20px 0',
            justifyContent: 'center',
          }}
        >
          {props.generalComparativeReport.evaluations.length > 0 &&
            props.generalComparativeReport.evaluations
              .filter((s) => catalogingKeys.some((key, index) => s[`gradeC${index + 1}`] > 0))
              .map((s, index) => (
                <div className="bar-wrapper" key={index}>
                  <div className="flex">
                    {catalogingKeys.map((key, colorIndex) => {
                      const gradeKey = `gradeC${colorIndex + 1}`;
                      return (
                        <div key={gradeKey}>
                          <div
                            className="value"
                            style={{ color: colors[colorIndex % colors.length] }}
                          >
                            {s[gradeKey]}%
                          </div>
                          <div
                            className="bar"
                            style={{
                              height: s[gradeKey] * 3.5,
                              backgroundColor: colors[colorIndex % colors.length],
                              maxWidth: '25px',
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="description">{s.courseName}</div>
                </div>
              ))}
        </div>
      </div>
    </Card>
  );
};

ReportBarChartComparative.propTypes = {};

ReportBarChartComparative.defaultProps = {
  title: '',
};

export default ReportBarChartComparative;
